var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpSign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10399",
    "data-name": "Group 10399",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.25,
    height: 20,
    viewBox: "0 0 20.25 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3042",
    "data-name": "Rectangle 3042",
    width: 12.396,
    height: 11.853,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10159",
    "data-name": "Group 10159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10055",
    "data-name": "Group 10055"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2970",
    "data-name": "Rectangle 2970",
    width: 20.25,
    height: 20,
    rx: 10,
    fill: "#4a90f7"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10166",
    "data-name": "Group 10166",
    transform: "translate(3.927 4.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10165",
    "data-name": "Group 10165",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3242",
    "data-name": "Path 3242",
    d: "M124.87,1.283l-1.114,3.055c-.015.041-.032.082-.053.138l-1.864-.683c.015-.047.027-.087.041-.127.348-.947.7-1.893,1.043-2.841a1.171,1.171,0,0,1,.912-.806.207.207,0,0,0,.043-.02h.194a.851.851,0,0,1,.611.456,5.021,5.021,0,0,1,.188.513Z",
    transform: "translate(-112.474)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3243",
    "data-name": "Path 3243",
    d: "M151.682.969a5.026,5.026,0,0,0-.188-.513A.851.851,0,0,0,150.883,0h.8Z",
    transform: "translate(-139.285 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3244",
    "data-name": "Path 3244",
    d: "M3.976,48.308c.168-.063.334-.134.5-.186a.775.775,0,0,1,.855.395.14.14,0,0,0,.107.067,1.382,1.382,0,0,1,.959.4c.1.091.2.174.3.265a.485.485,0,0,1,.055.656.479.479,0,0,1-.67.088c-.119-.089-.228-.192-.338-.293a.483.483,0,0,0-.336-.141,1.746,1.746,0,0,1-.277-.018.774.774,0,0,1-.606-.389c-.129.066-.249.139-.377.193a.771.771,0,0,1-1.05-.356,1.218,1.218,0,0,1-.087-.857c0-.028.011-.055.016-.083a.217.217,0,0,0,0-.042c-.04.025-.074.047-.109.067A9.123,9.123,0,0,1,2,48.591a1.336,1.336,0,0,1-1.4-.148A1.415,1.415,0,0,1,.1,47.627a3.787,3.787,0,0,1-.055-1.488A10.161,10.161,0,0,1,.56,44.007a3.578,3.578,0,0,1,.905-1.467,2.164,2.164,0,0,1,1.177-.621,1.383,1.383,0,0,1,1.21.418,2.677,2.677,0,0,1,.723,1.574,1.782,1.782,0,0,1,.024.216.482.482,0,0,1-.455.5.5.5,0,0,1-.511-.42,7.466,7.466,0,0,0-.2-.768,1.122,1.122,0,0,0-.188-.321.521.521,0,0,0-.736-.147,1.9,1.9,0,0,0-.726.71,5.27,5.27,0,0,0-.6,1.637c-.089.429-.154.863-.209,1.3a1.926,1.926,0,0,0,.082.836.353.353,0,0,0,.484.269,2.694,2.694,0,0,0,.487-.234c.322-.182.633-.385.961-.553a1.463,1.463,0,0,1,.477-.119c.48-.062.7.218.656.67-.026.259-.1.513-.145.77,0,.023-.006.046-.008.055",
    transform: "translate(0 -38.684)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3245",
    "data-name": "Path 3245",
    d: "M97.129,58.912,99,59.6c-.1.274-.2.541-.294.807-.409,1.114-.8,2.232-1.233,3.339a4.585,4.585,0,0,1-1.292,1.828.991.991,0,0,0-.335.471.225.225,0,0,1-.3.177.229.229,0,0,1-.12-.34.88.88,0,0,0,.037-.529,4.846,4.846,0,0,1-.055-1,4.417,4.417,0,0,1,.264-1.466c.194-.5.371-1,.555-1.505l.865-2.355.043-.115",
    transform: "translate(-88.057 -54.384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3246",
    "data-name": "Path 3246",
    d: "M107.477,4.212a1.69,1.69,0,0,1-.046.186q-.576,1.561-1.156,3.122a.479.479,0,0,1-.449.345.458.458,0,0,1-.413-.267.512.512,0,0,1,.007-.41q.547-1.469,1.091-2.94a2.284,2.284,0,0,1,.1-.257.447.447,0,0,1,.512-.224.465.465,0,0,1,.349.446",
    transform: "translate(-97.274 -3.463)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSign);
export default __webpack_public_path__ + "static/media/op-sign.e19f3bd7e44c61b2172c4b783daa0eeb.svg";
export { ForwardRef as ReactComponent };